import { createFileRoute } from '@tanstack/react-router'
import { InscriptionExpirePage } from '@/pages/InscriptionExpirePage'

export const Route = createFileRoute('/inscription/expire')({
  component: InscriptionExpirePage,
})
